import type { RequestExtraValue } from 'Models/uiConfig/requestTypes';

export default function queryParamsFromObject(obj: RequestExtraValue, prefix = ''): string {
  return paramsArrayFromObject(obj, prefix).join('&').replace(/\.=/g, '=');
}

function paramsArrayFromObject(obj: RequestExtraValue, prefix: string): string[] {
  const resArr: string[] = [];
  if (obj) {
    if (Array.isArray(obj)) {
      obj.forEach((innerObj) => resArr.push(...paramsArrayFromObject(innerObj, prefix)));
    } else if (typeof obj === 'object') {
      Object.entries(obj).forEach(([key, value]) => {
        resArr.push(...paramsArrayFromObject(value, `${prefix}${key}.`));
      });
    } else {
      resArr.push(`${prefix}=${obj}`);
    }
  }
  return resArr;
}
